import React from "react";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

import moment from "moment";

export default ({ headings, data }) => {
  return (
    <TableContainer>
      <Table size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            {headings.map((heading) => (
              <TableCell key={heading}>{heading}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <TableRow key={row.note_id}>
              <TableCell component="th" scope="row">
                {moment(row.timestamp).format("DD/MM/YYYY HH:MM:SS")}
              </TableCell>
              <TableCell>{row.title}</TableCell>
              <TableCell>{row.log}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
